// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React from 'react';
import {Text} from '@fluentui/react-northstar';
import './errorPage.scss';
import languageObject from "../../translations";
import {useParams} from "react-router-dom";

const ErrorPage = () => {
    const {id} = useParams<{ id: string }>();

    function parseErrorMessage(): string {
        if (id) {
            if (id === "401") {
                return languageObject.translate("UnauthorizedErrorMessage");
            } else if (id === "403") {
                return languageObject.translate("ForbiddenErrorMessage");
            }
        }
        return languageObject.translate("GeneralErrorMessage");
    }

    return (
        <Text content={parseErrorMessage()} className="error-message" error size="medium"/>
    );
};

export default ErrorPage;